module.exports = __webpack_public_path__ + "media/bootstrap-icons/folder-check-bf0bf61c.svg";